import React from 'react'
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
import Card from '@mui/material/Card';

import MDTypography from 'dashboard/components/MDTypography';
import MDButton from 'dashboard/components/MDButton';

const advantages = [{icon:'star', text : 'Accès exclusif à la demande, à des produits de haute qualité'},
                    {icon:'info', text :'Support marketing et promotionnel personnalisé'},
                    {icon:'local_library', text :'Formation continue pour optimiser vos ventes'},
                    {icon:'support_agent', text :'Service client réactif et dédié'},
                    {icon:'trending_up', text :'Opportunités de croissance et d’expansion'}
                  ];

function CallToAction() {
  return (
    <Card sx={{p:{xs:1, lg:2}, mb :2}}>
      <MDTypography variant="body2">
      "Rejoignez notre réseau de distributeurs et boostez votre activité avec <MDTypography color="primary" sx={{fontWeight:600}} variant="button" gutterBottom>GRANITEX BC</MDTypography> !"
      </MDTypography>
      <List sx={{my:2}} >
        {advantages.map(ele =>(
          <ListItem key={ele.icon}>
            <ListItemIcon>
              <Icon sx={{m:.5, minWidth:40}} color="primary" fontSize="medium">{ele.icon}</Icon>
            </ListItemIcon>
            <ListItemText
              secondary={ele.text}
            />
          </ListItem>
        ))}
        </List>
        <MDButton color="success" variant="gradient" component={Link} to={'/distributer/subscribe'}>Devenir Distributeur</MDButton>
    </Card>
  )
}

export default CallToAction
